import { render, staticRenderFns } from "./ControlSetting.vue?vue&type=template&id=43c7c5c9&scoped=true"
import script from "./ControlSetting.vue?vue&type=script&lang=js"
export * from "./ControlSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c7c5c9",
  null
  
)

export default component.exports